import { render, staticRenderFns } from "./wisdomClass.vue?vue&type=template&id=4f7c4f12&scoped=true"
import script from "./wisdomClass.vue?vue&type=script&lang=js"
export * from "./wisdomClass.vue?vue&type=script&lang=js"
import style0 from "./wisdomClass.vue?vue&type=style&index=0&id=4f7c4f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c4f12",
  null
  
)

export default component.exports